import { handleActions } from 'redux-actions';

import demoChannel from 'shared/constants/demo-channel';

import { APP_SETTINGS_UPDATE } from 'widget/redux/client/actions/app-settings';
import { NAMES as CHANNEL_GET } from 'shared/redux/server/actions/channel/get';

let prevChannelIdFromSettings;

export default handleActions({
  [APP_SETTINGS_UPDATE]: (state, { payload }) => {
    if (!payload.fonts) {
      return state;
    }

    // For a case when user had channel and then removed it, so it falls back to demoId
    // When any setting in appSettings changes, it retries to fetch deleted channel, that
    // said goes into finite loop of GET/FAIL actions.
    const nextChannelId = _.get(payload, 'fonts.channelId');

    if (prevChannelIdFromSettings === nextChannelId) {
      return state || demoChannel.id;
    }

    prevChannelIdFromSettings = nextChannelId;

    return prevChannelIdFromSettings || state || demoChannel.id;
  },
  [CHANNEL_GET.FAIL]: (state, { payload }) => {
    if (_.get(payload, 'response.error.code') === -7710) {
      return demoChannel.id;
    }

    return state;
  },
}, null);



// WEBPACK FOOTER //
// ./src/widget/redux/client/reducers/current-channel-id.js